import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Typography } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/CheckCircle';
import ErrorIcon from '@material-ui/icons/Error';
import InfoIcon from '@material-ui/icons/Info';
import WarningIcon from '@material-ui/icons/Warning';
const variants = {
  small: 'body1',
  large: 'h5'
};
const icons = {
  error: ErrorIcon,
  info: InfoIcon,
  success: CheckIcon,
  warning: WarningIcon
};
const useStyles = makeStyles(theme => ({
  alert: {
    alignItems: 'center',
    backgroundColor: ({
      type
    }) => theme.palette[type][50],
    border: ({
      type
    }) => `1px solid ${theme.palette[type][900]}`,
    borderRadius: '0.1875em',
    display: 'flex',
    margin: theme.spacing(1, 0),
    padding: theme.spacing(1)
  },
  alertText: {
    color: ({
      type
    }) => theme.palette[type][900]
  },
  icon: {
    fill: ({
      type
    }) => theme.palette[type][900],
    marginRight: theme.spacing(1)
  }
}));

const Alert = props => {
  const {
    children,
    elementType,
    size,
    type
  } = props;
  const classes = useStyles({
    type
  });
  const Icon = icons[type];
  return React.createElement("div", {
    className: `${classes.alert} ${classes[type]}`,
    role: "alert"
  }, React.createElement(Icon, {
    className: classes.icon,
    fontSize: size
  }), React.createElement(Typography, {
    className: classes.alertText,
    component: elementType,
    variant: variants[size]
  }, children));
};

Alert.propTypes = {
  /**
   * What HTML element will be used to compose the component.
   */
  elementType: PropTypes.string,
  size: PropTypes.oneOf(['small', 'large']),
  type: PropTypes.oneOf(['error', 'info', 'success', 'warning']).isRequired
};
Alert.defaultProps = {
  elementType: 'h2',
  size: 'small'
};
export default Alert;